import { render } from "./PostComponent.vue?vue&type=template&id=4bc773b4&scoped=true"
import script from "./PostComponent.vue?vue&type=script&lang=js"
export * from "./PostComponent.vue?vue&type=script&lang=js"

import "./PostComponent.vue?vue&type=style&index=0&id=4bc773b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc773b4"]])

export default __exports__